// src/lib/plansCatalog.js — Catalogue d'achat des formules (grille juin 2026).
//
// Copie FRONTEND de la grille — la source de vérité backend (quotas, montants,
// gating) vit dans api/_lib/plans.js : toute modification ici doit y être
// répercutée (et inversement). Seules les formules publiques figurent ici.
//
// Unités visibles client : messages (requêtes conversationnelles) et actes
// (générations d'actes / analyses de dossier). Blocage net à 100% du quota,
// alerte à 80%.

export const PLANS_CATALOG = [
  {
    key: "essentiel",
    label: "Essentiel",
    price: "249€",
    period: "/mois",
    messages: 500,
    actes: 20,
    seats: 1, // multi-siège non encore disponible (fast-follow) — paliers de volume mono-utilisateur
    features: ["500 messages / mois", "20 actes & analyses", "1 utilisateur", "Secrétariat IA inclus"],
  },
  {
    key: "cabinet",
    label: "Cabinet",
    price: "549€",
    period: "/mois",
    messages: 1500,
    actes: 60,
    seats: 1, // multi-siège non encore disponible (fast-follow) — paliers de volume mono-utilisateur
    highlight: true,
    features: ["1 500 messages / mois", "60 actes & analyses", "Recherche juridique + sociétés", "Multi-postes — bientôt"],
  },
  {
    key: "cabinet_plus",
    label: "Cabinet+",
    price: "1 190€",
    period: "/mois",
    messages: 5000,
    actes: 200,
    seats: 1, // multi-siège non encore disponible (fast-follow) — paliers de volume mono-utilisateur
    features: ["5 000 messages / mois", "200 actes & analyses", "Multi-postes — bientôt", "Support prioritaire"],
  },
];

export const TRIAL_SUMMARY = "Essai gratuit 14 jours — 50 messages · 3 actes";
